import NeighborhoodPage from './neighborhood-page';
export default NeighborhoodPage;